export const APPLE_STORE = 'https://apps.apple.com/cl/app/afp-planvital/id1437275304';
export const PLAY_STORE = 'https://play.google.com/store/apps/details?id=cl.planvital.app&hl=es_CL';
